import React from 'react';
import styled from "@emotion/styled";
import Loader from './XLoader';

const StyledLoaderScreen = styled.div(({ fadeOut }) => (`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--body-background-color);
    opacity: ${fadeOut ? 0 : 1};
    transition: opacity 0.25s ease-in-out;
`));

const LoaderScreen = ({ fadeOut, fadeOutDelay }) => {

    const [unmountPseudo, setUnmountPseudo] = React.useState(false);
    const [isMounted, setIsMounted] = React.useState(false);

    React.useEffect(() => {
        if (fadeOut) {
            setTimeout(() => {
                setIsMounted(false);
                setUnmountPseudo(true);
            }, fadeOutDelay);
        }
    }, [fadeOut, fadeOutDelay]);

    React.useEffect(() => {
        setIsMounted(true);
        return () => setIsMounted(false);
    }, []);

    return !unmountPseudo && (
        <StyledLoaderScreen fadeOut={fadeOut}>
            {isMounted && <Loader />}
        </StyledLoaderScreen>
    );
}

export default LoaderScreen;